import { type ReactNode } from 'react'

import { Icon } from '@/components/icons/Icon'
import { type DropdownOptionType, type InputProps } from '@/defs/input'
import { cn } from '@/utils/commonUtil'

import styles from './InputSelectCurrent.module.scss'

type Props = {
  options?: DropdownOptionType<string>[]
  placeholder?: string
  value?: string
  valueDisplay?: ReactNode
} & InputProps

export const InputSelectCurrent = ({ options = [], placeholder, size, value, valueDisplay }: Props) => (
  <span className={cn(styles.container, { isEmpty: !value, size, styles })}>
    <span className={styles.value}>
      {valueDisplay ? (
        valueDisplay
      ) : (
        <>
          <span className={cn(styles.option, styles.placeholder)}>{placeholder}</span>
          {options.map((o) => (
            <span className={cn(styles.option, { isSelected: o.value === value, styles })} key={o.value}>
              {o.label}
            </span>
          ))}
        </>
      )}
    </span>
    <span className={styles.icon}>
      <Icon name='caret' />
    </span>
  </span>
)
